import React, { Component, Fragment } from 'react';
import styles from './AppUser.module.css';
import { message } from 'antd';
import { Table, Icon, Tag, Form, Select, Input, Popconfirm, Button } from 'antd';
import WithError from 'HOC/Error/WithError';
import { axiosCms } from 'Axios.js';
import { connect } from 'react-redux';
import { updateAppUsers } from 'store/actions/index';
import { DateTime } from 'luxon';

const { Item } = Form;
const { Option } = Select;
const EditableContext = React.createContext();
const { Provider, Consumer } = EditableContext;

const OrderDropdown = props => {
  const handleUpdateOrder = value => {
    if (value === '') {
      return;
    }

    if (props.updateOrder !== undefined) {
      props.updateOrder({ by: props.by, order: value });
    }
  };

  const { by, order } = props;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {props.title}
      <Select
        defaultValue=""
        style={{ width: '70px', marginLeft: '1em' }}
        onChange={handleUpdateOrder}
        value={order.by === by ? order.order : ''}
      >
        <Select.Option value={''}></Select.Option>
        <Select.Option value={'asc'}>Asc</Select.Option>
        <Select.Option value={'desc'}>Desc</Select.Option>
      </Select>
    </div>
  );
};

const StatusDropdown = props => {
  const handleChangeSelectType = value => {
    if (props.updateStatus !== undefined) {
      props.updateStatus(value);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      Status
      <Select defaultValue="all" style={{ width: '90px', marginLeft: '1em' }} onChange={handleChangeSelectType}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value="pending">Pending</Select.Option>
        <Select.Option value="rejected">Rejected</Select.Option>
        <Select.Option value="deleted">Deleted</Select.Option>
      </Select>
    </div>
  );
};

const EditableRow = ({ form, index, ...props }) => {
  return (
    // we are writing the form object passed as
    // props from the Form.create() method antd gives us
    <Provider value={form}>
      <tr {...props} />
    </Provider>
  );
};

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends Component {
  selectAdminHandler = value => {
  };

  // renderInput is to decipher which type of input we want to pass in
  renderInput = () => {
    const { inputType } = this.props;
    if (inputType === 'select')
      return (
        <Select initialValue="SALES" style={{ width: 100 }} onChange={this.selectAdminHandler}>
          <Option value="SALES">Sales</Option>
          <Option value="STOCK">Stock</Option>
        </Select>
      );
    return <Input />;
  };

  // renderForm is rendering each cell in the table as a form
  renderForm = form => {
    const { getFieldDecorator } = form;
    const { editing, dataIndex, title, inputType, record, index, ...props } = this.props;

    const rules =
      inputType === 'text'
        ? [
            { type: 'email', message: 'The input is not valid E-mail!' },
            { required: true, message: 'Please input your E-mail!' },
          ]
        : [];

    return (
      <td {...props}>
        {editing ? (
          <Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: rules,
              initialValue: record[dataIndex],
            })(this.renderInput())}
          </Item>
        ) : (
          props.children
        )}
      </td>
    );
  };

  render() {
    return (
      // recomsuming the passed in form object from previously initialized Provider
      <Consumer>{form => this.renderForm(form)}</Consumer>
    );
  }
}

class AppUserTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      filter: {
        status: 'all',
      },
      order: {
        by: 'unix_updated_at',
        order: 'desc',
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.appUsers !== this.props.appUsers) {
      this.setState({
        list: this.props.appUsers,
      });
    }
  }

  updateFilterStatus = status => {
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        status: status,
      },
    });
  };

  updateOrderStatus = ({ by, order }) => {
    this.setState({
      ...this.state,
      order: {
        by: by,
        order: order,
      },
    });
  };

  toggleVisible = () => {
    this.setState(prev => ({ ...prev, visible: !this.state.visible }));
  };

  // render the type of role we wish to display
  renderRole = data => {
    if (data === 1) return 'Staff';
    else return 'Contractor';
  };

  // render status
  renderStatus = data => {
    if (data === 'Approved Staff') return <Tag color="green">Approved Staff</Tag>;
    else if (data === 'Pending') return <Tag color="magenta">Pending</Tag>;
    else if (data === 'Rejected') return <Tag color="red">Rejected</Tag>;
    else if (data === 'Deleted') return <Tag color="gray">Deleted</Tag>;
  };

  // is editing is a handler to check if the current record is the same
  // as the local editingID of the table so as to figure out if the row is primed for editing
  isEditing = record => {
    return record.id === this.state.editingID;
  };

  // editHandler sets the local state to save the current id of the row thats being edited on
  editHandler = id => {
    this.setState(prev => ({ ...prev, editingID: id }));
  };

  // if the editingID is 0, it means that no rows are currently being edited upon
  cancelHandler = () => {
    this.setState(prev => ({ ...prev, editingID: 0 }));
  };

  rejectHandler = id => {
    this.props.updateAppUsers(id, false);

    const tempList = [...this.state.list];

    const existed = this.state.list.findIndex(item => item.id === id);
    if (existed > -1) {
      tempList[existed].approval_status = 'Rejected';
      this.state.list = tempList;

      this.setState({
        list: tempList,
      });
    }
  };

  approveHandler = id => {
    this.props.updateAppUsers(id, true);

    const tempList = [...this.state.list];

    const existed = this.state.list.findIndex(item => item.id === id);
    if (existed > -1) {
      tempList[existed].approval_status = 'Approved Staff';
      this.state.list = tempList;

      this.setState({
        list: tempList,
      });
    }
  };

  // saveHandler handles the async call to server to store data
  saveHandler = (form, id) => {
    form.validateFields((error, row) => {
      if (error) return;
      this.props
        .updateAdmin(row, id)
        .then(() => {
          message.success('Update successful', 1);
          this.setState(prev => ({ ...prev, editingID: 0 }));
        })
        .catch(console.error);
    });
  };

  // renderSave renders the buttons to save and cancel out of an edit state
  renderSave = record => (
    <span>
      <Consumer>
        {form => (
          <a style={{ marginRight: 8 }} onClick={() => this.saveHandler(form, record.id)}>
            Save
          </a>
        )}
      </Consumer>
      <a onClick={() => this.cancelHandler()}>Cancel</a>
    </span>
  );

  // renderActions renderst the buttons to edit or delete during the non-edit state
  renderActions = record => (
    <Fragment>
      <Popconfirm
        key="Approve"
        title="Confirm accepting approval"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          this.approveHandler(record.id);
        }}
      >
        <Button variant="contained" color="secondary">
          Approve
        </Button>
      </Popconfirm>
      <Popconfirm
        key="Reject"
        title="Confirm rejecting approval"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          this.rejectHandler(record.id);
        }}
      >
        &nbsp;
        <Button variant="contained" color="secondary">
          Reject
        </Button>
      </Popconfirm>
    </Fragment>
  );

  renderRejectActions = record => (
    <Fragment>
      <Popconfirm
        key="Reject"
        title="Confirm rejecting approval"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          this.rejectHandler(record.id);
        }}
      >
        <Button variant="contained" color="secondary">
          Reject
        </Button>
      </Popconfirm>
    </Fragment>
  );

  renderApproveActions = record => (
    <Fragment>
      <Popconfirm
        key="Approve"
        title="Confirm accepting approval"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          this.approveHandler(record.id);
        }}
      >
        <Button variant="contained" color="secondary">
          Approve
        </Button>
      </Popconfirm>
    </Fragment>
  );

  renderTable = () => {
    const { isLoading } = this.props;
    const components = { body: { row: EditableFormRow, cell: EditableCell } };
    const list = (this.state.list || []).filter(item => {
      switch (this.state.filter.status) {
        case 'all':
          return true;
        case 'pending':
          return item.approval_status === 'Pending';
        case 'rejected':
          return item.approval_status === 'Rejected';
        case 'deleted':
          return item.approval_status === 'Deleted';
        default:
          return true;
      }
    });
    list.sort((a, b) => {
      const by = this.state.order.by;
      const parsedA = `${a[by]}`;
      const parsedB = `${b[by]}`;

      if (this.state.order.order === 'desc') {
        return parsedB.localeCompare(parsedA);
      }

      return parsedA.localeCompare(parsedB);
    });
    const columns = [
      {
        title: <OrderDropdown title="Name" by="name" order={this.state.order} updateOrder={this.updateOrderStatus} />,
        dataIndex: 'name',
        width: '200px',
      },
      {
        title: <OrderDropdown title="Phone" by="phone" order={this.state.order} updateOrder={this.updateOrderStatus} />,
        dataIndex: 'phone',
        width: '200px',
      },
      {
        title: (
          <OrderDropdown title="Company" by="company" order={this.state.order} updateOrder={this.updateOrderStatus} />
        ),
        dataIndex: 'company',
        width: '200px',
      },
      {
        title: 'Role',
        dataIndex: 'role',
        render: row => this.renderRole(row),
      },
      {
        title: <StatusDropdown updateStatus={this.updateFilterStatus} />,
        dataIndex: 'approval_status',
        render: row => this.renderStatus(row),
      },
      {
        title: (
          <OrderDropdown
            title="Updated At"
            by="unix_updated_at"
            order={this.state.order}
            updateOrder={this.updateOrderStatus}
          />
        ),
        dataIndex: 'updated_at',
        width: '200px',
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        width: '220px',
        render: (t, record) => {
          if (record.approval_status === 'Pending') {
            return this.renderActions(record);
          } else if (record.approval_status === 'Approved Staff') {
            return this.renderRejectActions(record);
          } else if (record.approval_status === 'Rejected') {
            return this.renderApproveActions(record);
          }

          return;
        },
      },
    ];

    // mapping through the columns on finding out which column is editable
    // and returning them with an onCell method
    // https://ant.design/components/table/#onCell
    // onCell sets the props of per cell which gets passed into
    // EditableCell class from the components props on <Table/>
    const columnsEditing = columns.map(col => {
      if (!col.editable) return col;
      return {
        ...col,
        onCell: record => {
          return {
            record,
            inputType: col.dataIndex === 'role' ? 'select' : 'text',
            dataIndex: col.dataIndex,
            title: col.title,
            editing: this.isEditing(record),
            width: col.dataIndex === 'role' ? '135px' : '400px',
          };
        },
      };
    });

    // components attribute
    // https://ant.design/components/table/#components
    // overrides the default table elements to provide extended capabilites
    // in this case, we want to pass in our EditableRow and EditableCell components
    // which are imbued with addition properties from the {form} object.

    return (
      <Table
        components={components}
        bordered
        loading={isLoading}
        className={styles.Table}
        rowKey={record => `${record.id}_${record.phone_id}`}
        dataSource={list}
        columns={columnsEditing}
      />
    );
  };

  render() {
    return <Fragment>{this.renderTable()}</Fragment>;
  }
}

const mapDispatchToProps = { updateAppUsers };

export default connect(null, mapDispatchToProps)(WithError(AppUserTable, axiosCms));



// WEBPACK FOOTER //
// ./src/components/Admin/AppUser/Table/AppUserTable.js